export const onAttrChangeInElement = (
  el: HTMLElement,
  observerOptions: MutationObserverInit,
  cb: (updatedElement: HTMLElement, done: () => void) => void
) => {
  let observer: MutationObserver | null = new MutationObserver(changes => {
    changes.forEach(({
      attributeName, oldValue, target,
    }) => {
      const newValue = (target as HTMLElement).getAttribute(
        attributeName as string
      );
      if (newValue !== oldValue) {
        cb(target as HTMLElement, done);
      }
    });
  });

  const done = () => {
    observer && observer.disconnect();
    observer = null;
  };

  observer.observe(el, observerOptions);

  return done;
};
